import { render, staticRenderFns } from "./DashboardPreview.vue?vue&type=template&id=534ba28d"
import script from "./DashboardPreview.vue?vue&type=script&lang=js"
export * from "./DashboardPreview.vue?vue&type=script&lang=js"
import style0 from "./DashboardPreview.vue?vue&type=style&index=0&id=534ba28d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports